import { Component, Input } from '@angular/core';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { DynamicFormControl } from './model/dynamic-form-control.model';
import { DatePickerComponent } from '@app/form-controls/date-picker/date-picker.component';

@Component({
  selector: 'c-dynamic-form',
  imports: [SharedModule, ReactiveFormsModule, DatePickerComponent],
  templateUrl: './dynamic-form.component.html'
})
export class DynamicFormComponent {

  @Input() formStructure: DynamicFormControl[];
  @Input() dynamicForm: FormGroup;
  @Input() showErrors = true;
}
